export const MerchantSelectionViewUat = {
  title: 'merchantSelection.title',
  description: 'merchantSelection.description',
  merchantsLocatorTitle: 'merchantSelection.merchantsLocatorTitle',
  assetSubtypeSelect: 'merchantSelection.assetSubtypeSelect',
  assetSubtypeItem: 'merchantSelection.assetSubtypeItem',
}
